import { Link } from "react-router-dom";
import { WifiOff } from "lucide-react";
import { useOnline } from "@/lib/offline";
import { useAuth } from "@/context/AuthContext";

export function OfflineBanner() {
  const online = useOnline();
  const { user } = useAuth();
  if (online) return null;
  return (
    <div data-testid="offline-banner" className="bg-[#FFB800] text-[#0B0F19] text-sm px-4 py-2 flex items-center justify-center gap-2 font-semibold">
      <WifiOff className="h-4 w-4" /> You're offline.
      {user && <Link to="/trip" data-testid="offline-banner-trip" className="underline">Your saved trip still works</Link>}
    </div>
  );
}
